module.exports = __webpack_public_path__ + "7eeba704870298abe7b79202585c5a31.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/OTP-Background.jpg
// module id = 2037
// module chunks = 1